import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

import { CompanyApi } from '../../../shared/api.url';

import { AppConfig } from "../../../app.config"
import { ApiResponse } from '../../../shared/models/api.response';
import { environment } from 'environments/environment';


@Injectable()
export class CountryStateDropdownService {
  apiUrl = environment.apiBaseUrl

  constructor(
    public http: HttpClient,
    private appConfig: AppConfig
  ) {

  }

  getCountryList() {
    return this.http.get<ApiResponse>(this.apiUrl + CompanyApi.getCountryListApiUrl);
  }

  AddGlobalSelectedId(selectedIdModel: any) {
      return this.http.post<ApiResponse>(this.apiUrl +CompanyApi.addGlobalSelectedApiUrl, selectedIdModel);
    }
  

  getGlobalSelectedId() {
    
    return this.http.get<ApiResponse>(this.apiUrl +CompanyApi.getGlobalSelectedApiUrl);
  }

  getStateByCountry(countryId: number) {
    let params = new HttpParams().set('countryId', countryId.toString());
    return this.http.get<ApiResponse>(this.apiUrl + CompanyApi.getStateListApiUrl, { params: params });
  }
}
